<script setup>
import { onMounted, ref } from 'vue'
import {Icon, Input, ProfilePicture, Textarea} from '@components'
import moment from 'moment'

import CenterLayout from './CenterLayout.vue'

// const questions = ref("You've selected Jacob Jones. Now choose your preferred date please.")
const dateOptions = ref({
 today: `Today, ${moment().format('MMM D')}`,
 tomorrow: `Tomorrow, ${moment().add(1, 'days').format('MMM D')}`,
 choose_another_day: 'Choose another day'
})

const selectedDate = ref(null)

import Calendar from './Calendar.vue'

import { useChatCustomizer } from '@store/chatCustomizer';
const $chatCustomizer = useChatCustomizer();

import {useSettings} from '@store/settings';
const $settings = useSettings();

</script>

<template>
  <CenterLayout>
    <div class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10">
      <img @click="$chatCustomizer.changeSecondaryMenu('staff')" :src="Image('chat-customizer-top-banner.png')" class="opacity-30 cursor-pointer" alt="">
    </div>
    
    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto">
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Textarea v-model="$settings.settings.chat_widget.date.question"></Textarea>
      </div>
     
      <div class="flex gap-2 flex-wrap">
        <div v-for="option in Object.values(dateOptions)" :key="option" @click="selectedDate = option" class="flex items-center gap-2 rounded-[58px] p-[10px_24px_10px_15px] cursor-pointer border" :class="[selectedDate == option ? 'border-transparent bg-[#F2F4F7]' : 'border-[#D0D5DD]']">
            <!-- <Icon name="sun" size="20px"/> -->
            <div class="text-[#101828] text-base font-medium">{{ option }}</div>
        </div>
      </div>

      <div>
        <Calendar v-if="selectedDate == 'Choose another day'"/>
      </div>
    </div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Date</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Set your date</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>


<style>

</style>